import { commaSeparate } from 'helpers/commaSeparate';
import { distanceInMiles } from 'helpers/distance';
import { DISTANCE_UNITS } from 'constants/measurement';
import { Venue } from 'models/Venue';

export class SearchVenue extends Venue {
  constructor(data = {}, config = {}) {
    super(data);
    const distance =
      data.distance && config.distanceUnit === DISTANCE_UNITS.mi ? distanceInMiles(data.distance) : data.distance;

    Object.assign(this, {
      activities: commaSeparate(data.activities, 2),
      distance: distance && Number(distance).toFixed(1),
      distanceUnit: config.distanceUnit,
      locationNameHighlighted: data.neighborhood_highlighted || this.locationName,
      nameHighlighted: data.name_highlighted || this.name,
      searchId: data.search_id,
    });
  }
}
